"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredResultsBySearch = exports.groupResultsBySportAndTournament = void 0;
const omit_1 = __importDefault(require("lodash/omit"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const events_1 = require("../events");
const groupResultsBySportAndTournament = (results, sportId) => {
    const groupedBySportId = sportId
        ? { [sportId]: results }
        : (0, groupBy_1.default)(results, 'tournament.sportId');
    return (0, mapValues_1.default)(groupedBySportId, (eventsBySport) => {
        const groupByTournamentId = (0, groupBy_1.default)(eventsBySport, 'tournament.id');
        return (0, mapValues_1.default)(groupByTournamentId, (eventsByTournament) => ({
            tournament: eventsByTournament[0].tournament,
            events: eventsByTournament.map((eventWithTournament) => (0, omit_1.default)(eventWithTournament, 'tournament')),
        }));
    });
};
exports.groupResultsBySportAndTournament = groupResultsBySportAndTournament;
const getFilteredResultsBySearch = ({ results, searchText, }) => {
    return (results
        .map((result) => {
        const filteredEvents = (0, events_1.searchEventsByCompetitorsName)({
            events: result.events,
            searchText,
        });
        if (filteredEvents.length) {
            return { ...result, filteredEvents };
        }
        else {
            return undefined;
        }
    })
        // filter because if we do not get any event after filter, we do not add championship and events respectively
        .filter(Boolean));
};
exports.getFilteredResultsBySearch = getFilteredResultsBySearch;
//# sourceMappingURL=index.js.map